import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import { setPreview as setPreviewAction } from "Actions/commonAction";
import arrowDown from "Assets/Svg/arrow-down.svg";
import logo from "Assets/Svg/sumhr-logo.svg";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import highFiveImg from "Assets/Svg/undraw-high-five.svg";
import facebookIcon from "Assets/Svg/social-media/facebook.svg";
import twitterIcon from "Assets/Svg/social-media/twitter.svg";
import linkedinIcon from "Assets/Svg/social-media/linkedin.svg";
import linkedinIconWhite from "Assets/Svg/linkedin-white.svg";

import pinterestIcon from "Assets/Svg/social-media/pinterest.svg";
import Button from "@material-ui/core/Button";
import copyIcon from "Assets/newicons/action/copy/outline/copy-outline-16-px.svg";
import ReactPhoneInput from "react-phone-input-2";
import checkIcon from "Assets/newicons/action/check/glyph/check-plain-glyph-16-px.svg";
import ScreeningQuestions from "Module/Subscription/ConfigMode/Recruit/JobsCreation/ScreeningQuestions";
import Questions from "./Questions";
import DocumentUpload from "./DocumentUpload";
import PersonalDetails from "./PersonalDetails";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

const POSTDATA = {
  contacttypevalue: "",
  fullname: "",
  email: "",
  city: "",
  phonenumber: "",
  institutename: "",
  coursename: "",
  graduatingyear: "",
  courseTypes: [],
  courseId: "",
  employmentTypes: [],
  companyname: "",
  title: "",
  EmploymentTypeId: "",
  endDate: "",
  startDate: "",
  advancedProficiency: "",
  workingProficiency: "",
  elementaryProficiency: "",
  linkedInRef: "",
  behanceRef: "",
  githubRef: "",
  dribbbleRef: "",
  websiteRef: "",
  twitterRef: "",
  applicationForm: false,
  documentUpload: false,
  screeningQuestions: false,
  savedSuccess: false,
};

class CandidateApplication extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      postdata: POSTDATA,
      permissions: { editable: true, readonly: true },
      contacttypevalue: "",
      fullname: "",
      email: "",
      city: "",
      phonenumber: "",
      institutename: "",
      coursename: "",
      graduatingyear: "",
      courseTypes: [],
      courseId: "",
      employmentTypes: [],
      companyname: "",
      title: "",
      EmploymentTypeId: "",
      endDate: "",
      startDate: "",
      advancedProficiency: "",
      workingProficiency: "",
      elementaryProficiency: "",
      linkedInRef: "",
      behanceRef: "",
      githubRef: "",
      dribbbleRef: "",
      websiteRef: "",
      twitterRef: "",
      applicationForm: false,
      documentUpload: false,
      screeningQuestions: false,
      savedSuccess: false,
    };
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.uploadDocument = this.uploadDocument.bind(this);
    this.openScreeningQuestion = this.openScreeningQuestion.bind(this);
    this.submit = this.submit.bind(this);
  }

  handleChange(key, value) {
    this.setState({
      [key]: value,
    });
  }

  OnPhoneChange(key, value) {
    this.setState({
      [key]: value,
    });
  }

  handleTabChange(value) {
    this.setState({
      value,
    });
  }

  SelecttoDate(args) {
    const date = this.ConvertDate(args.value);
    const endDate = date;
    this.setState({ endDate });
  }

  SelectStartDate(args) {
    const date = this.ConvertDate(args.value);
    const startDate = date;
    this.setState({ startDate });
  }

  uploadDocument() {
    this.setState({
      documentUpload: true,
      applicationForm: false,
    });
  }

  openScreeningQuestion() {
    this.setState({
      documentUpload: false,
      screeningQuestions: true,
    });
  }

  submit() {
    this.setState({
      savedSuccess: true,
      screeningQuestions: false,
    });
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const {
      applicationForm,
      documentUpload,
      screeningQuestions,
      savedSuccess,
    } = this.state;
    return (
      <div style={{ padding: 32, paddingBottom: 0 }}>
        <div className="margin-bottom-32">
          <img src={logo}></img>
        </div>
        <Grid container className="fluid-container">
          <Grid item xs={12} md={7} sm={12}>
            <h1
              style={{
                color: "#010709",
                fontSize: 40,
                marginTop: 0,
                marginBottom: 0,
              }}
            >
              Senior Front End Developer
            </h1>
            <p
              style={{
                color: "#545556",
                fontSize: 24,
                marginRight: 16,
                fontWeight: "bold",
              }}
            >
              Bangalore • Product • Full Time
            </p>
          </Grid>
          {!applicationForm &&
            !documentUpload &&
            !screeningQuestions &&
            !savedSuccess && (
              <Grid item xs={12} md={5} sm={12} className="text-align-right">
                <div
                  style={{
                    display: "inline-flex",
                  }}
                >
                  <p
                    style={{
                      color: "#1e8ced",
                      fontSize: 24,
                      marginRight: 16,
                      fontWeight: "bold",
                    }}
                  >
                    Apply for this position
                  </p>
                  <a href="#applyposition">
                    <div
                      style={{
                        width: 72,
                        height: 72,
                        background: "#1e8ced",
                        borderRadius: 72,
                        position: "relative",
                        boxShadow: "0 7px 16px 0 rgba(0, 0, 0, 0.16)",
                      }}
                    >
                      <img src={arrowDown} className="vertical-center"></img>
                    </div>
                  </a>
                </div>
              </Grid>
            )}
        </Grid>

        {applicationForm ? (
          <PersonalDetails
            uploadDocument={this.uploadDocument}
            {...this.state}
            postdata={this.state.postdata}
          />
        ) : documentUpload ? (
          <DocumentUpload
            openScreeningQuestion={this.openScreeningQuestion}
            {...this.state}
            {...this.props}
            postdata={this.state.postdata}
          />
        ) : screeningQuestions ? (
          <Questions submit={this.submit} />
        ) : savedSuccess ? (
          <Grid
            container
            className="fluid-container text-center"
            style={{ background: "#f9f9f9" }}
          >
            <Grid item xs={12} md={12} sm={12}>
              <p
                style={{
                  color: "#010709",
                  fontSize: 24,

                  fontWeight: "bold",
                  marginBottom: 16,
                }}
              >
                Your application has been successfully submitted!
              </p>
              <p
                style={{
                  color: "#010709",
                  fontSize: 22,
                  margin: "24px auto 64px",
                }}
              >
                Our team will reach out to you for further rounds of screening.
                Please feel free to share this job posting in the meanwhile!
              </p>
            </Grid>
            <Grid item xs={12} md={6} sm={12}>
              <img src={highFiveImg}></img>
            </Grid>
            <Grid item xs={12} md={6} sm={12}>
              <div className="rounded-rectangle-div">
                <p
                  className="large-text-dark-secondary ellipsis width90 inline-block"
                  style={{ textAlign: "left" }}
                >
                  www.goldline.sumhr.io/jobs/abskjsco...
                </p>
                <img src={copyIcon}></img>
              </div>
              <div className="margin-top-24">
                <img src={twitterIcon} className="margin-right-16"></img>
                <img src={facebookIcon} className="margin-right-16"></img>
                <img src={linkedinIcon} className="margin-right-16"></img>
                <img src={pinterestIcon}></img>
              </div>
              <Button
                className="btn btn-primary-md-blue margin-top-40"
                variant="contained"
                // onClick={() => this.setState({ drawerOpen: true })}
              >
                View all openings
              </Button>
            </Grid>
          </Grid>
        ) : (
          <div>
            <Grid
              container
              style={{ background: "#f9f9f9" }}
              className="fluid-container"
            >
              <Grid item xs={12} md={9} sm={12}>
                <p className="normal-dark t-bold margin-bottom-24">
                  Job description
                </p>
                <p
                  className="small-dark-secondary"
                  style={{ textAlign: "justify", width: "90%" }}
                >
                  It’s an audacious, incredibly rewarding mission that our
                  increasingly diverse team is dedicated to achieving. Airbnb is
                  built around the idea that everyone should be able to take the
                  perfect trip, including where they stay, what they do, and who
                  they meet. To that end, we empower millions of people around
                  the world to use their spaces, passions, and talents to become
                  entrepreneurs. Exciting challenges lie ahead—new regions,
                  technologies, and businesses. Guided by our four core values,
                  we’ll meet these challenges creatively and with the support of
                  our global community. Join us! It’s an audacious, incredibly
                  rewarding mission that our increasingly diverse team is
                  dedicated to achieving. Airbnb is built around the idea that
                  everyone should be able to take the perfect trip, including
                  where they stay, what they do, and who they meet. To that end,
                  we empower millions of people around the world to use their
                  spaces, passions, and talents to become entrepreneurs.
                  Exciting challenges lie ahead—new regions, technologies, and
                  businesses. Guided by our four core values, we’ll meet these
                  challenges creatively and with the support of our global
                  community. Join us!
                </p>
              </Grid>
              <Grid item xs={12} md={3} sm={12}>
                <p className="normal-dark t-bold margin-bottom-16">Location</p>
                <p className="small-dark-secondary margin-bottom-48">
                  Bangalore, India
                </p>
                <p className="normal-dark t-bold margin-bottom-16">Job type</p>
                <p className="small-dark-secondary margin-bottom-48">
                  Full time employment
                </p>
                <p className="normal-dark t-bold margin-bottom-16">
                  Experience
                </p>
                <p className="small-dark-secondary margin-bottom-48">
                  4+ years
                </p>
                <p className="normal-dark t-bold margin-bottom-16">
                  Department
                </p>
                <p className="small-dark-secondary">Product</p>
              </Grid>
            </Grid>
            <Grid container style={{ margin: "64px 0" }} id="applyposition">
              <Grid item xs={12} md={12} sm={12}>
                <p
                  style={{
                    color: "#010709",
                    fontSize: 24,
                    marginBottom: 32,
                    fontWeight: "bold",
                    textAlign: "center",
                    marginTop: 0,
                  }}
                >
                  Apply for this position
                </p>
                <div
                  style={{
                    background: "#2774b1",
                    padding: 16,
                    width: 270,
                    display: "flex",
                    borderRadius: 4,
                    margin: "0 auto",
                    cursor: "pointer",
                  }}
                  // onClick={() => this.setState({ applicationForm: true })}
                >
                  <img src={linkedinIconWhite}></img>
                  <p
                    className="normal-dark margin-left-16"
                    style={{ fontSize: 22, color: "#fff" }}
                  >
                    Apply with LinkedIn
                  </p>
                </div>
                <p className="large-text-small-dark-secondary text-center margin-top-8">
                  - or -
                </p>
                <div
                  className="display-flex"
                  style={{ justifyContent: "center" }}
                >
                  <div style={{ width: 250, marginRight: 8 }}>
                    <p className="input-label">Apply with phone number</p>
                    <ReactPhoneInput
                      defaultCountry={"in"}
                      countryCodeEditable={true}
                      className="form-control"
                      value={this.state.contacttypevalue}
                      onChange={(value) =>
                        this.OnPhoneChange("contacttypevalue", value)
                      }
                      InputProps={{ maxLength: 15, minLength: 5 }}
                    />
                  </div>

                  <div
                    style={{
                      width: 44,
                      height: 44,
                      background: "#1e8ced",
                      borderRadius: 72,
                      position: "relative",
                      boxShadow: "0 7px 16px 0 rgba(0, 0, 0, 0.16)",
                      margin: 16,
                    }}
                    onClick={() => this.setState({ applicationForm: true })}
                  >
                    <img src={checkIcon} className="vertical-center"></img>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        )}

        {/* <Grid
          container
          style={{ background: "#f9f9f9", padding: "88px 0" }}
          className="fluid-container text-center"
        >
          <Grid item xs={12} md={12} sm={12}>
            <p className="normal-dark">Powered by</p>
            <img src={logo}></img>
          </Grid>
        </Grid> */}
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(CandidateApplication)));
